export type APIErrorData = {
  statusCode: number;
  error: string;
  message: string;
  nodeId?: string;
  commonTriggers?: [];
  /** Machine-readable reason, sent by endpoints that need one status code to mean several things. */
  code?: string;
};

export default class APIError extends Error {
  statusCode: number;
  error: string;
  nodeId?: string;
  commonTriggers?: [];
  code?: string;

  constructor({ statusCode, error, message, nodeId, commonTriggers, code }: APIErrorData) {
    super(message);
    this.statusCode = statusCode;
    this.error = error;
    this.nodeId = nodeId;
    this.commonTriggers = commonTriggers;
    this.code = code;
  }
}
